(() => {
  function syncCartTitles() {
    const header = document.querySelector('[data-header-cart-title]');
    if (!header) return;

    const title = header.textContent.trim();
    if (!title) return;

    document.querySelectorAll('[data-cart-title]').forEach((heading) => {
      if (heading.textContent !== title) heading.textContent = title;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartTitles, { once: true });
  } else {
    syncCartTitles();
  }

  document.addEventListener('shopify:section:load', syncCartTitles);
  document.addEventListener('cart:page:rendered', syncCartTitles);
  document.addEventListener('cart:drawer:rendered', syncCartTitles);
})();
